import { format, parseISO, isValid } from "date-fns";

/**
 * Formats a date to dd/MM/yyyy
 * @param {Date|string} dateValue
 * @returns {string}
 */
export const formatDate = (dateValue) => {
  if (!dateValue) return "-";

  let date;
  if (typeof dateValue === "string") {
    // Check if it's already in a ISO format or similar
    date = parseISO(dateValue);
    // If parseISO fails, try new Date()
    if (!isValid(date)) {
      date = new Date(dateValue);
    }
  } else {
    date = dateValue;
  }

  if (!isValid(date) || Number.isNaN(date.getTime())) return "-";

  return format(date, "dd/MM/yyyy");
};

/**
 * Formats a date with time to dd/MM/yyyy hh:mm a
 * @param {Date|string} dateValue
 * @returns {string}
 */
export const formatDateTime = (dateValue) => {
  if (!dateValue) return "-";

  let date;
  if (typeof dateValue === "string") {
    date = parseISO(dateValue);
    if (!isValid(date)) {
      date = new Date(dateValue);
    }
  } else {
    date = dateValue;
  }

  if (!isValid(date) || Number.isNaN(date.getTime())) return "-";

  return format(date, "dd/MM/yyyy hh:mm a");
};
